<template>
  <div :id="markId" class="form-card-list-container">
    <el-collapse v-model="curCollapse" :accordion="accordion" :class="className" @change="change">
      <slot />
    </el-collapse>
  </div>
</template>

<script>
import '../../../../lib/styles/components/FormCardList.scss'
export default {
  name: 'FormCardList',
  provide() {
    return {
      formCardList: this
    }
  },
  props: {
    // 是否为手风琴模式（true同时只存在一个打开）
    accordion: {
      type: Boolean,
      default: false
    },
    // 当前激活的面板
    activePanel: {
      type: [String, Array],
      default: () => []
    },
    change: {
      type: Function,
      default: () => {}
    },
    errorPosition: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formCardContainerList: [],
      cardNameList: [],
      markId: '',
      openCardList: [] // 默认开启子项配置了shrink: false
    }
  },
  computed: {
    curCollapse() {
      return [...this.activePanel, ...this.openCardList]
    }
  },
  created() {
    // 设置独有id
    this.markId = 'formCard' + (new Date().getTime()) + Math.ceil(Math.random() * 10000)
  },
  mounted() {
    if (this.errorPosition) {
      // 当前formCardList对象
      const curCard = document.getElementById(this.markId)
      this.formCardContainerList = curCard.getElementsByClassName('form-card-container')
      for (const item of this.formCardContainerList) {
        this.cardNameList.push(item.getAttribute('data-mark'))
      }
    }
  },
  methods: {
    // 聚焦第一个错误表单
    focusFirstFormItem() {
      if (this.errorPosition) {
        const errorList = document.getElementsByClassName('is-error')
        if (errorList && errorList.length > 0) {
          let curInput
          errorList.forEach((item, index) => {
            if (index === 0) {
              curInput = item
            }
          })
          curInput = curInput.getElementsByClassName('el-input__inner')
          // console.log('curInput--', curInput)
          // 打开有错误表单的面板
          this.toggleCard()
          this.$nextTick(() => {
            // console.log('聚焦')
            curInput[0].focus()
          })
        }
      }
    },
    // 判断当前form-card是否有校验未过表单
    toggleCard() {
      this.formCardContainerList.forEach((item, index) => {
        const errorList = item.getElementsByClassName('is-error')
        // console.log(`${this.cardNameList[index]}--`, errorList)
        if (errorList && errorList.length > 0) {
          this.curCollapse.push(this.cardNameList[index])
        } else {
          const curIndex = this.curCollapse.indexOf(this.cardNameList[index])
          if (curIndex > -1) {
            this.curCollapse.splice(curIndex, 1)
          }
        }
      })
    }
  }
}
</script>
